<template>
  <div class="logo">
    <div class="circle">
      <!--  下拉菜单-->
      <el-dropdown @command="handleCommand"><!--  绑定指令,在methods里定义-->
        <span class="el-dropdown-link">
          <!-- 您好 -->
          <el-avatar :size="45" :src="circleUrl"></el-avatar>
          <span>{{UserName}}</span>
          <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- icon是修改图标 ，command是点击后传给方法的值-->
          <el-dropdown-item icon="el-icon-edit" command="edit">修改密码</el-dropdown-item>
          <el-dropdown-item icon="el-icon-s-operation" command="quit">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      UserName:"",
    }
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'edit':
          // console.log('修改密码')
          this.$alert('正在开发中...', '修改密码', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: action => {
              this.$message({
                type: 'info',
                message: `已取消修改`
              });
            }
          });

          break;
        case 'quit':
          this.$confirm('此操作将退出当前帐号, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // console.log('退出登录')
            // 退出成功，清除本地数据
            let that = this;
            that.$store.commit("delToken");
            that.$store.commit("delID");
            that.$store.commit("delUserName");
            // 回到登录页面，重新登录
            this.$router.push('/')
            this.$message({
              type: 'success',
              message: '退出成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消退出'
            });
          });






          break;

        default:
          break;
      }
    }
  },
  mounted() {
    this.UserName = localStorage.getItem('userName');
  },
}
  </script>
  <style lang="less" scoped>
.logo {
  height: 81px;
  padding: 0 30px;
}
.circle {
  height: 45px;
  margin-top: 20px;
  float: right;
  span {
    vertical-align: middle;
    margin-left: 10px;
    font-family: "微软雅黑";
    font-weight: bold;
    font-size: 20px;
  }
}
</style>
  